// Shipping region codes
export const EVERYWHERE_CODE = 'XX';
export const US_CON = 'US_CON';
export const US_AK = 'US_AK';
export const US_HI = 'US_HI';
export const US_PR = 'US_PR';
export const US_OTHER = 'US_OTHER';

// Country codes
export const US = 'US';

export const NUMBER_OR_FLOAT_KEYS_REGEX = /\d|\.|\,|\s/;

export const experiments = {
  OFFER_QUANTITY: 'offer_quantity',
  ITEM_LOGGED_OUT_RECENTLY_VIEWED: 'item_logged_out_recently_viewed',
  CSP_NO_INVENTORY: 'csp_no_inventory',
  OFFER_RECS: 'offer_recs',
  V3_OFFERS: 'v3_offers',
  CSP_BUYBOX: 'csp_buybox',
  CSP_RECENT_LISTINGS: 'csp_recent_listings',
  SHOW_SIMILAR_LISTINGS: 'show_similar_listings',
};

export const CORE_DEFAULT_OG_IMAGE_URL =
  'https://static.reverb-assets.com/assets/homepage/open-graph-2a0cbbc49a26d873db03aae487defc6d.jpg';

export const LP_NATIVE = 'lp_native';
export const IOS = 'ios';
export const ANDROID = 'android';
export const MOBILE_PHONE = 'mobile_phone';
export const TABLET = 'tablet';
export const WEB = 'web';

export enum CmsPageType {
  BUYING_GUIDE = 'buying_guide',
  CATEGORY = 'category',
  FEATURED = 'featured',
  GEAR = 'gear',
  LEGAL = 'legal',
  PRESS = 'press',
  PROMO = 'promo',
  ROOT = 'root',
  SALE = 'sale',
  SELLING = 'selling',
}

export const NO_NEW_TAB_CSP_SLUGS = [
  'focusrite-scarlett-2i2-3rd-gen-usb-audio-interface',
  'shure-sm57',
  'mxr-micro-amp',
  'electro-harmonix-rams-head-big-muff-pi-distortion-slash-sustainer-2019',
  'boss-katana-50-mkii-50-watt-1x12-digital-modeling-guitar-combo',
  'ibanez-ts9-tubescreamer',
];



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/constants.ts